import { connect } from 'react-redux';
import { getAvailableEntertainments } from '../redux/actions/availableEntertainments';
import { getBookedEntertainments } from '../redux/actions/bookedEntertainments';
import { saveEntertainment, deleteEntertainment } from '../redux/actions/changeAddon';
import DineAroundDetail from '../components/dineAroundDetail/DineAroundDetail';
import { shouldFetch, filterBookedEntertainments, shouldFetchAvailableItems } from '../utils';
import { getShouldDineAroundSkip } from '../dineAround/dineAroundHelper';

const mapStateToProps = ({ availableEntertainments, bookingSearch, bookedEntertainments, bookedEvents, config, dineAround }, { dineAroundId }) => ({
  dineAroundItems: availableEntertainments.dineAroundItems,
  title: 'Setup your experience',
  subTitle: 'Dine Around',
  optionTitle: 'Select performance time...',
  separatorLabel: 'Venue closed for deep clean',
  resId: bookingSearch.resId,
  siteCode: bookingSearch.siteCode,
  arrivalDate: bookingSearch.arrivalDate,
  dineAroundId,
  shouldFetchAvailableEntertainments: shouldFetchAvailableItems(availableEntertainments, bookingSearch, config, bookedEntertainments),
  shouldSkip: getShouldDineAroundSkip(availableEntertainments, bookingSearch, config),
  bookedEntertainmentsWithoutPastEvents: filterBookedEntertainments(availableEntertainments.dineAroundItems, bookedEntertainments.entertainments),
  shouldFetchBookedEntertainments: shouldFetch(bookedEntertainments, bookingSearch, config),
  numOfUnits: bookingSearch.numOfUnits,
  numOfGuests: bookingSearch.numOfGuests,
  bookedEvents: bookedEvents.events,
  openVenuesForBreakfast: dineAround.openVenuesForBreakfast,
  openVenuesForDinner: dineAround.openVenuesForDinner,
  refreshTimeInterval: parseInt(config.REACT_APP_REFRESH_TIME_INTERVAL, 10) || 15,
  lastConfigCheckDateTime: config.lastConfigCheckDateTime,
  breakfastCutoff: config.REACT_APP_DINE_AROUND_BREAKFAST_CUTOFF || '07:45',
  afternoonCutoff: config.REACT_APP_DINE_AROUND_AFTERNOON_CUTOFF || '11:50',
  afternoonStartTime: config.REACT_APP_DINE_AROUND_AFTERNOON_STARTTIME || '12:00',
  afternoonEndTime: config.REACT_APP_DINE_AROUND_AFTERNOON_ENDTIME || '16:00',
  eveningCutoff: config.REACT_APP_DINE_AROUND_EVENING_CUTTOFF || '16:00',
  eveningStartTime: config.REACT_APP_DINE_AROUND_EVENING_STARTTIME || '16:01',
  eveningEndTime: config.REACT_APP_DINE_AROUND_EVENING_ENDTIME || '23:59',
});

const mapDispatchToProps = dispatch => ({
  getAvailableEntertainments: siteCode => dispatch(getAvailableEntertainments(siteCode)),
  getBookedEntertainments: (resId, siteCode) => dispatch(getBookedEntertainments(resId, siteCode)),
  saveEntertainment: (entertainmentsToSave, type) => dispatch(saveEntertainment(entertainmentsToSave, type)),
  deleteEntertainment: (resId, siteCode, timeSlotId, eventDate, startTime, endTime, name, needToReportToGTM) => dispatch(
    deleteEntertainment(resId, siteCode, timeSlotId, eventDate, startTime, endTime, name, needToReportToGTM),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(DineAroundDetail);
